import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../shared/components/Button";
import Typography from "../../shared/components/Typography";
import { Link as RouterLink } from "react-router-dom";
import { Grid, Theme, WithStyles } from "@material-ui/core";
import { h5 } from "../../shared/styles";
import SplashImageView from "../../shared/views/SplashImageView";
import { AppLinkHrefs } from "../../navigation/navigationHelpers";

const styles = (theme: Theme) => ({
  ...h5(theme),
  button: {
    minWidth: 200,
    align: "center",
  },
  header: {
    marginTop: theme.spacing(4),
    [theme.breakpoints.up("sm")]: {
      marginTop: theme.spacing(0),
    },
  },
  grid: {
    marginTop: theme.spacing(0),
    [theme.breakpoints.up("sm")]: {
      marginTop: theme.spacing(4),
    },
    flexGrow: 1,
  },
});

function HeroUnit(props: WithStyles<typeof styles>) {
  const { classes } = props;

  return (
    <SplashImageView backgroundImage="/background.jpg" loadingColor="#05060f">
      <Typography
        className={classes.header}
        color="inherit"
        align="center"
        variant="h2"
        marked="center"
      >
        Learn how to quickly build a modern web app
      </Typography>
      <Typography
        color="inherit"
        align="center"
        variant="h5"
        className={classes.h5}
      >
        Best practices, guides, and source code. Take advantage of decades of
        experience, written by a former Facebook and Microsoft engineer.
        <br />
        <br />
        Build fast with React, Firebase, Typescript, and Material-UI.
      </Typography>
      <Grid
        className={classes.grid}
        container
        spacing={4}
        justify="center"
        direction="row"
      >
        <Grid key="cta1" item>
          <Button
            color="secondary"
            variant="contained"
            size="large"
            className={classes.button}
            component={RouterLink}
            to={AppLinkHrefs.Introduction}
          >
            Start Building
          </Button>
        </Grid>
      </Grid>
    </SplashImageView>
  );
}

export default withStyles(styles)(HeroUnit);
